import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { OrganisationsListPage } from '@organisations/feature';

export const Route = createFileRoute('/_app/_admin/organisations')({
  component: OrganisationsListPage,
});
